import ShoppingBagOutlined from "@mui/icons-material/ShoppingBagOutlined";
import ShoppingBag from "@mui/icons-material/ShoppingBag";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useWarehouseShoppingListBuffer } from "../../../../../../contexts/WarehouseShoppingListBuffer";

// "Add to shopping list" toggle for an opened item - same buffer as the
// table row checkbox (WarehouseTable.jsx), same shape as
// WarehouseLabelBufferToggle.jsx but for the shopping list buffer.
export default function WarehouseShoppingListToggle({ item, testId }) {
  const { t } = useTranslation();
  const { isBuffered, toggle } = useWarehouseShoppingListBuffer();
  const buffered = isBuffered(item.id);

  return (
    <IconButton
      onClick={() => toggle(item)}
      title={t(buffered ? "RemoveFromShoppingList" : "AddToShoppingList")}
      size="small"
      data-testid={testId}
    >
      {buffered ? (
        <ShoppingBag fontSize="small" color="primary" />
      ) : (
        <ShoppingBagOutlined fontSize="small" />
      )}
    </IconButton>
  );
}
